import { Button, Drawer, Form, Input, Select, Space } from "antd";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import TextArea from "antd/es/input/TextArea";

const EditEmployee = ({
  open,
  close,
  setLoading,
  rerun,
  selectedData,
  positionList,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  const [form] = Form.useForm();
  const [provinceList, setProvinceList] = useState({ data: [], ready: false });
  const [cityList, setCityList] = useState({ data: [], ready: false });
  const [barangayList, setBarangayList] = useState({ data: [], ready: false });

  const handleEditEmployee = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("id", selectedData !== null ? selectedData.id : "");
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    setLoading(true);
    axios
      .post("user/commissary/edit-employee", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Edited employee successfully.");
          setTimeout(() => {
            close();
            form.setFieldsValue({
              firstname: "",
              middlename: "",
              lastname: "",
              street: "",
              barangay: "",
              city: "",
              province: "",
              contact_no: "",
              position: "",
            });
            setLoadings(false);
            setLoading(false);
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  const getAllProvinces = () => {
    axios
      .get("user/admin/province-list")
      .then((response) => {
        const data = response.data;
        setProvinceList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleGetCityByProvince = (value) => {
    var params = { province_description: value };
    setCityList({ data: [], ready: false });
    setBarangayList({ data: [], ready: false });
    axios
      .get("user/admin/city-list", { params })
      .then((response) => {
        const data = response.data;
        setCityList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  const handleGetBarangayByCity = (value) => {
    var params = { city_municipality_description: value };
    setBarangayList({ data: [], ready: false });
    axios
      .get("user/admin/barangay-list", { params })
      .then((response) => {
        const data = response.data;
        setBarangayList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    getAllProvinces();
  }, []);

  return (
    <Drawer
      title="Edit Employee"
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <Form
          form={form}
          layout="vertical"
          name="basic"
          initialValues={{
            firstname: selectedData.firstname,
            middlename:
              selectedData.middlename === null ? "" : selectedData.middlename,
            lastname: selectedData.lastname,
            street: selectedData.street,
            barangay: selectedData.barangay,
            city: selectedData.city,
            province: selectedData.province,
            contact_no: selectedData.contact_no,
            position: parseInt(selectedData.position),
          }}
          onFinish={handleEditEmployee}
          autoComplete="off"
        >
          <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
            <Form.Item
              name="firstname"
              label="Firstname"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Input placeholder="Set firstname" size="large" />
            </Form.Item>
            <Form.Item
              name="middlename"
              label="Middlename"
              rules={[
                {
                  required: false,
                  message: "Required",
                },
              ]}
            >
              <Input placeholder="Set middlename" size="large" />
            </Form.Item>
            <Form.Item
              name="lastname"
              label="Lastname"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Input placeholder="Set lastname" size="large" />
            </Form.Item>

            <Form.Item
              name="province"
              label="Province"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select province"
                onChange={handleGetCityByProvince}
                size="large"
                showSearch
              >
                {provinceList.data.length > 0 ? (
                  provinceList.data.map((data, index) => (
                    <Select.Option
                      value={data.province_description}
                      key={index}
                    >
                      {data.province_description}
                    </Select.Option>
                  ))
                ) : (
                  <Select.Option value="">No province found!</Select.Option>
                )}
              </Select>
            </Form.Item>
            <Form.Item
              name="city"
              label="City"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select city"
                onChange={handleGetBarangayByCity}
                size="large"
                showSearch
              >
                {cityList.data.length > 0 ? (
                  cityList.data.map((data, index) => (
                    <Select.Option
                      value={data.city_municipality_description}
                      key={index}
                    >
                      {data.city_municipality_description}
                    </Select.Option>
                  ))
                ) : (
                  <Select.Option value="">No city found!</Select.Option>
                )}
              </Select>
            </Form.Item>
            <Form.Item
              name="barangay"
              label="Barangay"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select barangay"
                size="large"
                showSearch
                style={{ textTransform: "uppercase" }}
              >
                {barangayList.data.length > 0 ? (
                  barangayList.data.map((data, index) => (
                    <Select.Option
                      value={data.barangay_description}
                      key={index}
                      style={{ textTransform: "uppercase" }}
                    >
                      {data.barangay_description}
                    </Select.Option>
                  ))
                ) : (
                  <Select.Option value="">No barangay found!</Select.Option>
                )}
              </Select>
            </Form.Item>
            <Form.Item
              name="street"
              label="Street|House No.|Bldg. No.|Apartment"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <TextArea
                placeholder="Set street|house no.|bldg. no.|apt"
                autoSize
                size="large"
                style={{ textTransform: "uppercase" }}
              />
            </Form.Item>

            <Form.Item
              name="contact_no"
              label="Contact No."
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Input placeholder="Set contact number" size="large" />
            </Form.Item>
            <Form.Item
              name="position"
              label="Position"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <Select
                placeholder="Select position"
                size="large"
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {positionList.data.length > 0 ? (
                  positionList.data.map((data, index) => (
                    <Select.Option value={data.id} key={index}>
                      {data.position}
                    </Select.Option>
                  ))
                ) : (
                  <Select.Option value="">No position found!</Select.Option>
                )}
              </Select>
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Update"}
            </Button>
          </Form.Item>
        </Form>
      )}
    </Drawer>
  );
};

export default EditEmployee;
